import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronDown, faTrash } from '@fortawesome/pro-solid-svg-icons';
import UnstyledDropdownToggle from '../bootstrap_extensions/unstyled_dropdown_toggle';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import DownloadButton from '../download_button';
import { v4 as uuid } from 'uuid';

export default function PhotoBulkActions({
  allSelected,
  bulkDownloadLink,
  disabled,
  label = 'Property Photos',
  showLimit,
  onBulkAttributeChange,
  onBulkDelete,
  onBulkDownload,
  onBulkPreview,
  onSelectAll
}) {
  const dropdownId = React.useRef(uuid());
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  return (
    <div className="mt-2 mb-3 d-flex align-items-center justify-content-between">
      <h3 className="m-0">
        {label}
        {showLimit && (<span className="text-muted ml-2 limit-label">(Limit: 100)</span>)}
      </h3>

      <div className="d-flex align-items-center gap-4">
        <div>
          <label className="ds-text-primary m-0 fw-normal d-flex align-items-center gap-2">
            <input
              checked={allSelected}
              className="m-0"
              style={{ width: '16px', height: '16px' }}
              type="checkbox"
              onChange={onSelectAll}
            />
            {allSelected ? 'Unselect' : 'Select'} all photos
          </label>
        </div>

        <Dropdown className="ds-dropdown" id={dropdownId.current} open={dropdownOpen} onToggle={setDropdownOpen}>
          <UnstyledDropdownToggle
            bsRole="toggle"
            className="ds-filter-button d-flex align-items-center justify-content-between"
            style={{ color: 'inherit' }}
          >
            Actions
            <FontAwesomeIcon icon={faChevronDown}/>
          </UnstyledDropdownToggle>
          <Dropdown.Menu>
            {typeof onBulkAttributeChange === 'function' && (
              <MenuItem disabled={disabled} onClick={() => onBulkAttributeChange('syndicate', true)}>
                <FontAwesomeIcon className="mr-2" fixedWidth icon={faCheckCircle}/>
                Approve for Syndication
              </MenuItem>
            )}
            <MenuItem disabled={disabled} onClick={onBulkPreview}>
              <FontAwesomeIcon className="mr-2" fixedWidth icon={faEye}/>
              Preview
            </MenuItem>
            {typeof onBulkDownload === 'function' && typeof bulkDownloadLink === 'string' && (
              <DownloadButton
                disabled={disabled}
                href={bulkDownloadLink}
                menuIconColor={false}
                menuIconSize="md"
                messageOverride="Download"
                type="MenuItem"
                onClick={() => {
                  onBulkDownload();
                  setDropdownOpen(false);
                }}
              />
            )}
            <MenuItem divider/>
            <MenuItem disabled={disabled} onClick={onBulkDelete}>
              <FontAwesomeIcon className="mr-2" fixedWidth icon={faTrash}/>
              Delete
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

PhotoBulkActions.propTypes = {
  allSelected: PropTypes.bool.isRequired,
  bulkDownloadLink: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  showLimit: PropTypes.bool.isRequired,
  onBulkAttributeChange: PropTypes.func,
  onBulkDelete: PropTypes.func.isRequired,
  onBulkDownload: PropTypes.func,
  onBulkPreview: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
};
